import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';


import * as distributionConstants from '../distributionConstants';
import * as distributionFormConstants from './distributionFormConstants';

import FormBlock from '../../../../global/Form/FormBlock';
import FormCheckbox from '../../../../global/Form/FormElement/FormCheckbox';
import FormCountrySelect from '../../../../global/Form/FormCountrySelect';
import FormSlider from '../../../../global/Form/FormElement/FormSlider';
import ShortNumber from '../../../../global/Numeric/ShortNumber';
import ValidatingForm from '../../../../global/Form/ValidatingForm';


function DistributionForm({distribution, isPrimaryDisabled, formId, onData}) {

    const {formatMessage} = useIntl();

    const numberValueRenderer = (value, {stepIndex, isLast}) => (
        <>
            {stepIndex === 1 && '<'}
            {isLast && '>'}
            <ShortNumber value={value}/>
        </>
    );

    return (
        <ValidatingForm
            data={distribution}
            id={formId}
            key={`${formId}${distribution.isPrimary}`}
            onIsInvalid={data => onData(data, false)}
            onIsValid={data => onData(data, true)}
            validationSchema={distributionFormConstants.SCHEMA_DISTRIBUTION}
        >
            {({form}) => {

                return (
                    <FormBlock>

                        <FormCountrySelect
                            error={form.getCurrentError('countryAlpha2', 'distribution.form')}
                            id={`${formId}CountryAlpha2`}
                            isRequired={form.isRequired('countryAlpha2')}
                            labelI18n={'distribution.form.field.countryAlpha2.label'}
                            name={`${formId}CountryAlpha2`}
                            onChange={countryAlpha2 => form.setData({countryAlpha2})}
                            placeholder={formatMessage({id: 'address.form.field.countryAlpha2.placeholder'})}
                            value={form.getData('countryAlpha2')}
                        />

                        <FormCheckbox
                            id={`${formId}IsPrimary`}
                            isChecked={form.getData('isPrimary')}
                            isDisabled={isPrimaryDisabled}
                            labelI18n={'distribution.form.field.isPrimary.label'}
                            name={`${formId}IsPrimary`}
                            onChange={isPrimary => form.setData({isPrimary})}
                        />

                        <FormSlider
                            error={form.getCurrentError('reachDigital', 'distribution.form')}
                            id={`${formId}ReachDigital`}
                            isRequired={form.isRequired('reachDigital')}
                            labelI18n={'distribution.form.field.reachDigital.label'}
                            max={distributionFormConstants.REACH_MAX_DIGITAL}
                            min={0}
                            name={`${formId}ReachDigital`}
                            onChange={reachDigital => form.setData({reachDigital})}
                            step={distributionFormConstants.REACH_MAX_DIGITAL_SLIDER_STEP}
                            thumbValueRenderer={numberValueRenderer}
                            value={form.getData('reachDigital')}
                        />

                        <FormSlider
                            error={form.getCurrentError('reachPrint', 'distribution.form')}
                            id={`${formId}ReachPrint`}
                            isRequired={form.isRequired('reachPrint')}
                            labelI18n={'distribution.form.field.reachPrint.label'}
                            max={distributionFormConstants.REACH_MAX_PRINT}
                            min={0}
                            name={`${formId}ReachPrint`}
                            onChange={reachPrint => form.setData({reachPrint})}
                            step={distributionFormConstants.REACH_MAX_PRINT_SLIDER_STEP}
                            thumbValueRenderer={numberValueRenderer}
                            value={form.getData('reachPrint')}
                        />

                    </FormBlock>
                );
            }}
        </ValidatingForm>
    );
}


DistributionForm.propTypes = {
    distribution: distributionConstants.DISTRIBUTION_SHAPE,
    formId: PropTypes.string,
    isPrimaryDisabled: PropTypes.bool,
    onData: PropTypes.func.isRequired
};

DistributionForm.defaultProps = {
    formId: 'distribution.form',
    isPrimaryDisabled: false
};


export default DistributionForm;
